import Seo from "@/components/Seo";
import Breadcrumb from "@/components/Breadcrumb";
import PricingTabs from "@/components/PricingTabs";
import { IdentityLabel } from "@/components/ui-bits";

export default function Pricing() {
  return (
    <div data-testid="pricing-page">
      <Seo
        title="Harga Digital Marketing Medan & Paket Layanan | Digitalis"
        description="Daftar lengkap harga dan paket Digitalis untuk social media marketing, website, konten, influencer, SEO, Google Maps, dan layanan digital di Medan."
        canonicalPath="/pricing"
      />
      <section className="mx-auto max-w-[1400px] px-5 pb-5 pt-10 md:px-10 md:pb-8 md:pt-14">
        <Breadcrumb items={[{ label: "Home", to: "/" }, { label: "Harga & Paket" }]} />
        <div className="mt-7 grid gap-5 lg:grid-cols-[1fr_0.75fr] lg:items-end">
          <div>
            <IdentityLabel>Transparan & Mudah Dibandingkan</IdentityLabel>
            <h1 className="font-display text-[2.35rem] font-extrabold leading-tight tracking-tightest sm:text-5xl md:text-6xl">Harga & Paket Digitalis</h1>
          </div>
          <p className="text-base text-muted-foreground md:text-lg lg:pb-1">Pilih kategori layanan untuk melihat seluruh paket, manfaat, tujuan, dan ketentuannya tanpa bagian yang disembunyikan.</p>
        </div>
      </section>
      <PricingTabs fullDetails heading={false} />
    </div>
  );
}
